import React, { FC } from 'react';
import { connectDeep } from '../../../redux-utils';

import App from '../../../models/app';
import ContentGrid from '../AppContentGrid/ContentGrid';
import ItemGrid from '../AppContentGrid/ItemGrid';
import AppShapedImage from '../AppShapedImage/index';
import { roundEdgeDevices } from '../../../constants';

interface ClockListProps {
  apps: App[];
  collectionId?: string;
  deviceName: string;
}

const ClockListComponent: FC<ClockListProps> = ({ apps, collectionId, deviceName }) => {
  return (
    <ContentGrid>
      {apps.map((app) => {
        const queryParam = collectionId ? `?collectionId=${collectionId}` : '';
        const linkTo = `/v2/clock/${app.id}${queryParam}`;

        const photo = (
          <AppShapedImage
            photoProperties={{
              src: app.banners?.[0]?.uri || '',
              alt: app.name,
              width: app.banners?.[0]?.width,
              height: app.banners?.[0]?.height,
              isSquircle: roundEdgeDevices.includes(deviceName?.toLowerCase()),
            }}
            width={110}
            height={110}
            borderRadius="16px"
            borderReservedSpace={true}
          />
        );

        return (
          <ItemGrid
            key={app.id}
            id={app.id}
            title={app.name}
            subtitle={app.isInstalledOrInstalling ? 'installed' : undefined}
            linkTo={linkTo}
            photo={photo}
          />
        );
      })}
    </ContentGrid>
  );
};

const mapStateToProps = (state: any) => {
  const deviceName = state.registry.currentUser?.device?.productName || null;
  return {
    deviceName,
  };
};

export const ClockList = connectDeep(mapStateToProps)(ClockListComponent);